/* ==========================================================================
   lockin — producto: galería, zoom, variantes, compra, botón fijo, vista rápida
   y temporizador de demostración. Depende de window.theme (assets/theme.js).
   ========================================================================== */
(function () {
  'use strict';

  var theme = window.theme;
  if (!theme) return;

  var $ = theme.$;
  var $$ = theme.$$;
  var config = theme.config;
  var Cart = theme.Cart;
  var Dialog = theme.Dialog;

  /* Zoom de imagen
     ------------------------------------------------------------------------ */
  var lightbox = null;

  function openLightbox(src, alt) {
    if (!lightbox) {
      lightbox = document.createElement('dialog');
      lightbox.className = 'lightbox';
      var close = document.createElement('button');
      close.type = 'button';
      close.className = 'dialog__close';
      close.setAttribute('data-dialog-close', '');
      close.setAttribute('aria-label', config.strings.close || 'Cerrar');
      close.innerHTML =
        '<svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18"/></svg>';
      lightbox.appendChild(close);
      lightbox.appendChild(document.createElement('img'));
      document.body.appendChild(lightbox);
    }
    var image = $('img', lightbox);
    image.src = src;
    image.alt = alt || '';
    if (!Dialog.open(lightbox)) window.open(src, '_blank', 'noopener');
  }

  /* Ficha de producto
     ------------------------------------------------------------------------ */
  /* Ampliar fotos que no están dentro de una ficha de producto (p. ej. «Mírala de cerca»). */
  document.addEventListener('click', function (event) {
    var zoom = event.target.closest('[data-zoom]');
    if (zoom && !zoom.closest('[data-product]')) openLightbox(zoom.dataset.zoom, zoom.dataset.zoomAlt);
  });

  function initProducts(root) {
    $$('[data-product]', root).forEach(function (product) {
      if (product.dataset.ready) return;
      product.dataset.ready = 'true';

      var stage = $('[data-gallery-stage]', product);
      var slides = $$('.gallery__slide', product);
      var thumbs = $$('[data-thumb]', product);
      var form = $('[data-product-form]', product);
      var addButton = $('[data-add]', product);
      var addLabel = $('[data-add-label]', product);
      var stickyBar = $('[data-sticky-buy]', product);
      var stickyButton = $('[data-add-sticky]', product);
      var picker = $('[data-variant-picker]', product);

      /* Galería: miniaturas y deslizamiento */
      function goToMedia(mediaId, smooth) {
        var index = slides.findIndex(function (slide) {
          return slide.dataset.mediaId === String(mediaId);
        });
        if (index < 0 || !stage) return;
        stage.scrollTo({ left: index * stage.clientWidth, behavior: smooth && !theme.reducedMotion ? 'smooth' : 'auto' });
      }

      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          goToMedia(thumb.dataset.thumb, true);
        });
      });

      if (stage && thumbs.length && 'IntersectionObserver' in window) {
        var slideObserver = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (!entry.isIntersecting) return;
              thumbs.forEach(function (thumb) {
                if (thumb.dataset.thumb === entry.target.dataset.mediaId) {
                  thumb.setAttribute('aria-current', 'true');
                } else {
                  thumb.removeAttribute('aria-current');
                }
              });
            });
          },
          { root: stage, threshold: 0.6 }
        );
        slides.forEach(function (slide) {
          slideObserver.observe(slide);
        });
      }

      product.addEventListener('click', function (event) {
        var zoom = event.target.closest('[data-zoom]');
        if (zoom) openLightbox(zoom.dataset.zoom, zoom.dataset.zoomAlt);
      });

      /* Variantes: actualiza precio, imagen, disponibilidad y botones */
      if (picker) {
        var variants = [];
        try {
          variants = JSON.parse($('[data-variants]', picker).textContent);
        } catch (error) {
          variants = [];
        }

        picker.addEventListener('change', function () {
          var selected = $$('fieldset', picker).map(function (group) {
            var checked = $('input:checked', group);
            $('[data-option-label]', group).textContent = checked.getAttribute('data-label') || checked.value;
            return checked.value;
          });
          var variant = variants.filter(function (candidate) {
            return candidate.options.every(function (option, index) {
              return option === selected[index];
            });
          })[0];
          updateVariant(variant);
        });
      }

      /* Tiñe el fondo de la sección con el color de la variante elegida (lo usa el CSS). */
      function tintSection() {
        var section = product.closest('.section');
        if (!section || !picker) return;
        var swatch = $('input:checked + label .variants__swatch', picker);
        var color = swatch ? swatch.style.getPropertyValue('--swatch') : '';
        if (color) section.style.setProperty('--variant-tint', color.trim());
        else section.style.removeProperty('--variant-tint');
      }
      tintSection();
      window.addEventListener('load', function () { syncScene(); });

      /* La escena «Producto en movimiento» enseña las fotos del color elegido aquí. */
      function syncScene() {
        if (!picker) return;
        $$('input:checked', picker).forEach(function (input) {
          var value = input.getAttribute('data-color-key') || input.value.toLowerCase();
          $$('[data-spin-variant]').forEach(function (radio) {
            if (radio.value !== value || radio.checked) return;
            radio.checked = true;
            radio.dispatchEvent(new Event('change', { bubbles: true }));
          });
        });
      }

      /* Pack de 2 unidades: el precio de la ficha pasa al total con el descuento
         (el descuento real lo aplica Shopify en el carrito; aquí solo se muestra). */
      var pack = $('[data-pack]', product);

      function formatMoney(cents) {
        var format = config.moneyFormat || '{{amount}}';
        function number(decimals, thousands, decimal) {
          var fixed = (cents / 100).toFixed(decimals).split('.');
          var whole = fixed[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
          return fixed[1] ? whole + decimal + fixed[1] : whole;
        }
        return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (match, key) {
          switch (key) {
            case 'amount_no_decimals': return number(0, ',', '.');
            case 'amount_with_comma_separator': return number(2, '.', ',');
            case 'amount_no_decimals_with_comma_separator': return number(0, '.', ',');
            case 'amount_with_apostrophe_separator': return number(2, "'", '.');
            case 'amount_no_decimals_with_space_separator': return number(0, ' ', ',');
            case 'amount_with_space_separator': return number(2, ' ', ',');
            case 'amount_with_period_and_space_separator': return number(2, ' ', '.');
            default: return number(2, ',', '.');
          }
        });
      }

      function applyPack() {
        if (!pack) return;
        var chosen = $('input[name="quantity"]:checked', pack);
        var quantity = chosen ? parseInt(chosen.value, 10) || 1 : 1;
        var discount = packPercent(quantity);
        var unitCents = 0;
        $$('[data-price-cents]', product).forEach(function (node) {
          var base = parseInt(node.dataset.priceCents, 10);
          if (isNaN(base)) return;
          /* Con 1 unidad se deja el precio tal como lo formatea Shopify. */
          if (!node.hasAttribute('data-price-html')) node.setAttribute('data-price-html', node.innerHTML);
          if (quantity === 1) {
            node.innerHTML = node.getAttribute('data-price-html');
            return;
          }
          var isCompare = node.classList.contains('price__compare');
          /* Shopify descuenta caja a caja y redondea hacia abajo: 10 % de 24,99 € son 2,49 €
             por caja, así que 2 cajas cuestan 45,00 €. */
          var total = isCompare ? base * quantity : base * quantity - Math.floor((base * discount) / 100) * quantity;
          if (!isCompare && !unitCents) unitCents = Math.round(total / quantity);
          node.innerHTML = formatMoney(total);
        });
        syncUnits(quantity);
        /* Tarjetas de cantidad: el selector de color va dentro de la tarjeta elegida. */
        var slot = $('[data-pack-slot="' + quantity + '"]', pack);
        if (picker && slot && picker.parentNode !== slot) slot.appendChild(picker);
        var baseNode = $('[data-swap="price"] [data-price-cents]:not(.price__compare)', product);
        if (baseNode) {
          var unitPrice = parseInt(baseNode.dataset.priceCents, 10);
          $$('[data-pack-save]', pack).forEach(function (save) {
            var units = parseInt(save.dataset.qty, 10) || 2;
            var pct = parseFloat(save.dataset.pct) || packPercent(units);
            var cut = Math.floor((unitPrice * pct) / 100) * units;
            save.innerHTML = (save.dataset.template || '[amount]').replace('[amount]', formatMoney(cut));
          });
        }
        var summary = $('[data-sticky-summary]', product);
        if (summary) {
          var parts = [];
          $$('.variants__input:checked[data-label]', product).forEach(function (input) {
            if (!input.closest('[data-unit-picker]')) parts.push(input.getAttribute('data-label'));
          });
          var card = chosen ? chosen.closest('.pack__card') : null;
          var extra = card ? $$('[data-unit-picker] input:checked', card).map(function (input) {
            return input.getAttribute('data-label');
          }) : [];
          if (extra.length && parts.length) {
            var colours = [parts[parts.length - 1]].concat(extra);
            var unique = colours.filter(function (label, index) {
              return colours.indexOf(label) === index;
            });
            if (unique.length > 1) parts[parts.length - 1] = colours.join(' + ');
          }
          var chosenLabel = chosen ? $('label[for="' + chosen.id + '"]', pack) : null;
          var nameNode = chosenLabel ? $('[data-pack-name]', chosenLabel) || chosenLabel.firstChild : null;
          if (nameNode) parts.push(nameNode.textContent.trim());
          if (parts.length) summary.textContent = parts.join(' · ');
        }
        var box = $('[data-swap="price"] .price', product);
        var note = $('[data-pack-note]', product);
        /* Con tarjetas, el precio tachado y el ahorro ya se ven en la tarjeta de 2 cajas. */
        if (quantity > 1 && unitCents && box && !pack.classList.contains('pack--cards')) {
          if (!note) {
            note = document.createElement('span');
            note.className = 'price__unit';
            note.setAttribute('data-pack-note', '');
            var current = $('.price__current', box);
            current.parentNode.insertBefore(note, current.nextSibling);
          }
          /* Junto al total: lo que costarían por separado (tachado) y el ahorro real. */
          var saved = $('[data-pack-save]', pack);
          var single = parseInt(baseNode ? baseNode.dataset.priceCents : 0, 10);
          note.innerHTML = '';
          if (single) {
            var full = document.createElement('s');
            full.className = 'price__pack-full';
            full.textContent = formatMoney(single * quantity);
            note.appendChild(full);
            note.appendChild(document.createTextNode(' '));
          }
          note.appendChild(document.createTextNode(saved ? saved.textContent : ''));
        } else if (note) {
          note.parentNode.removeChild(note);
        }
      }

      /* Porcentaje de descuento por cantidad (2 cajas / 3 o más), según los ajustes. */
      function packPercent(quantity) {
        if (!pack || quantity < 2) return 0;
        if (quantity >= 3) return parseFloat(pack.getAttribute('data-pack-discount-3')) || 0;
        return parseFloat(pack.dataset.packDiscount) || 0;
      }

      /* Colores de las cajas 2.ª y 3.ª: siguen al de la 1.ª hasta que se cambian. */
      function syncUnits(quantity) {
        if (!pack) return;
        $$('[data-legend-single]', product).forEach(function (node) {
          node.hidden = quantity > 1;
        });
        $$('[data-legend-first]', product).forEach(function (node) {
          node.hidden = quantity < 2;
        });
        var firstId = $('[data-variant-id]', product);
        $$('[data-unit-picker]', pack).forEach(function (group) {
          if (group.dataset.touched || !firstId) return;
          var match = $('input[value="' + firstId.value + '"]', group);
          if (match) match.checked = true;
        });
      }

      /* Líneas para el pago: la 1.ª caja con el selector principal y el resto con el suyo. */
      function packLines(quantity) {
        var firstVariant = $('[data-variant-id]', product).value;
        var chosen = pack ? $('input[name="quantity"]:checked', pack) : null;
        var card = chosen ? chosen.closest('.pack__card') : null;
        var extra = card ? $$('[data-unit-picker] input:checked', card) : [];
        if (!extra.length) return [[firstVariant, quantity]];
        return [[firstVariant, 1]].concat(extra.map(function (input) {
          return [input.value, 1];
        }));
      }

      if (pack) {
        pack.addEventListener('change', function (event) {
          var unitGroup = event.target.closest('[data-unit-picker]');
          if (unitGroup) unitGroup.dataset.touched = 'true';
        });
        pack.addEventListener('change', applyPack);
        if (picker) picker.addEventListener('change', applyPack);
        applyPack();
      }

      function updateVariant(variant) {
        var available = !!(variant && variant.available);

        if (addButton) {
          var label = !variant
            ? addButton.dataset.labelUnavailable
            : available
            ? addButton.dataset.labelAdd
            : addButton.dataset.labelSoldout;
          addButton.disabled = !available;
          var buyNow = $('[data-buy-now]', product);
          if (buyNow) buyNow.disabled = !available;
          if (addLabel) addLabel.textContent = label;
          if (stickyButton) {
            stickyButton.disabled = !available;
            stickyButton.textContent = label;
          }
        }
        if (!variant) return;
        tintSection();
        syncScene();

        var idInput = $('[data-variant-id]', product);
        if (idInput) {
          idInput.value = variant.id;
          /* Avisa a los botones de pago dinámicos de Shopify del cambio de variante. */
          idInput.dispatchEvent(new Event('change', { bubbles: true }));
        }

        if (product.hasAttribute('data-update-url')) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url.toString());
        }

        if (variant.featured_media) goToMedia(variant.featured_media.id, true);

        /* La foto de la barra fija sigue al color elegido. */
        var stickyThumb = stickyBar ? $('.sticky-buy__thumb', stickyBar) : null;
        var variantImage = variant.featured_image && variant.featured_image.src;
        if (stickyThumb && variantImage) {
          stickyThumb.removeAttribute('srcset');
          stickyThumb.src = variantImage + (variantImage.indexOf('?') < 0 ? '?' : '&') + 'width=160';
        }

        /* Precio y disponibilidad se piden a Shopify para respetar formato de moneda,
           rebajas reales y precio por unidad. Mientras tanto, estado de carga. */
        var priceBox = $('[data-swap="price"]', product);
        if (priceBox) priceBox.setAttribute('aria-busy', 'true');
        fetch(product.dataset.url + '?variant=' + variant.id + '&section_id=' + product.dataset.sectionId)
          .then(function (response) {
            if (!response.ok) throw new Error('HTTP ' + response.status);
            return response.text();
          })
          .then(function (html) {
            var fresh = theme.parseHTML(html);
            ['price', 'price-sticky'].forEach(function (key) {
              var current = $('[data-swap="' + key + '"]', product);
              var next = $('[data-swap="' + key + '"]', fresh);
              if (current && next) current.innerHTML = next.innerHTML;
            });
            applyPack();
          })
          .catch(function () {
            /* si falla, el precio correcto se verá en el carrito */
          })
          .then(function () {
            if (priceBox) priceBox.removeAttribute('aria-busy');
          });
      }

      /* Añadir al carrito sin recargar, con estados de carga y error */
      if (form) {
        form.addEventListener('submit', function (event) {
          /* Compra directa: sin carrito, al pago con el color y la cantidad elegidos. */
          if (config.directCheckout) {
            event.preventDefault();
            var chosenQty = $('input[name="quantity"]:checked', product) || $('input[name="quantity"]', product);
            if (addButton) addButton.classList.add('is-loading');
            var qty = chosenQty ? parseInt(chosenQty.value, 10) || 1 : 1;
            theme.goCheckout(packLines(qty));
            return;
          }
          /* «Pagar» envía el formulario de forma normal: Shopify añade y redirige al checkout. */
          if (event.submitter && event.submitter.hasAttribute('data-buy-now')) return;
          event.preventDefault();

          /* Con carrito: se añaden las mismas líneas que en la compra directa (en un pack,
             cada caja con su color) y se abre el carrito lateral. */
          var chosenInput = $('input[name="quantity"]:checked', product) || $('input[name="quantity"]', product);
          var chosenQuantity = chosenInput ? parseInt(chosenInput.value, 10) || 1 : 1;
          var errorBox = $('[data-form-error]', form);
          if (errorBox) errorBox.hidden = true;
          [addButton, stickyButton].forEach(function (button) {
            if (!button) return;
            button.classList.add('is-loading');
            button.setAttribute('aria-busy', 'true');
          });

          Cart.addLines(packLines(chosenQuantity)).then(function (ok) {
            [addButton, stickyButton].forEach(function (button) {
              if (!button) return;
              button.classList.remove('is-loading');
              button.removeAttribute('aria-busy');
            });
            if (!ok) return;
            var hasDrawer = config.cartType === 'drawer' && Cart.drawer();
            if (!hasDrawer) {
              window.location.href = config.routes.cart;
              return;
            }
            if (!Cart.open()) {
              theme.toast({ title: config.strings.cartAdded, href: config.routes.cart, linkLabel: config.strings.viewCart });
            }
          });
        });
      }

      /* Barra de compra fija (todos los tamaños): aparece cuando el botón principal no se
         ve y se esconde mientras está en pantalla. Oculta, no se puede enfocar (inert). */
      if (stickyBar && addButton) {
        var ticking = false;
        var stickyShown = null;
        var toggleSticky = function () {
          var rect = addButton.getBoundingClientRect();
          var visible = rect.bottom > 0 && rect.top < window.innerHeight - 8;
          /* También al cargar: en pantallas muy bajas el botón puede quedar por debajo. */
          var show = !visible;
          if (show !== stickyShown) {
            stickyShown = show;
            stickyBar.classList.toggle('is-visible', show);
            stickyBar.setAttribute('aria-hidden', show ? 'false' : 'true');
            stickyBar.inert = !show;
            document.documentElement.classList.toggle('has-sticky-buy', show);
          }
          ticking = false;
        };
        window.addEventListener(
          'scroll',
          function () {
            if (ticking) return;
            ticking = true;
            window.requestAnimationFrame(toggleSticky);
          },
          { passive: true }
        );
        toggleSticky();
      }
    });
  }

  /* Vista rápida: pide la sección quick-view del producto y la muestra en un diálogo.
     Estados: cargando (esqueleto), error (con reintento) y contenido.
     ------------------------------------------------------------------------ */
  function initQuickView() {
    var dialog = $('[data-quick-view]');
    if (!dialog) return;
    var content = $('[data-quick-view-content]', dialog);

    var skeleton =
      '<div class="product"><div class="skeleton skeleton--media"></div>' +
      '<div class="skeleton-stack"><div class="skeleton skeleton--title"></div><div class="skeleton skeleton--text"></div>' +
      '<div class="skeleton skeleton--row"></div><div class="skeleton skeleton--row"></div></div></div>';

    function load(url) {
      content.setAttribute('aria-busy', 'true');
      content.innerHTML = skeleton;
      fetch(url + (url.indexOf('?') > -1 ? '&' : '?') + 'section_id=quick-view')
        .then(function (response) {
          if (!response.ok) throw new Error('HTTP ' + response.status);
          return response.text();
        })
        .then(function (html) {
          var fresh = $('[data-quick-view-root]', theme.parseHTML(html));
          if (!fresh) throw new Error('sin contenido');
          content.innerHTML = '';
          content.appendChild(document.importNode(fresh, true));
          theme.announceContent(content);
        })
        .catch(function () {
          content.innerHTML = '';
          var box = document.createElement('div');
          box.className = 'empty-state';
          var text = document.createElement('p');
          text.className = 'empty-state__title';
          text.textContent = config.strings.loadError;
          var link = document.createElement('a');
          link.className = 'btn btn--outline';
          link.href = url;
          link.textContent = config.strings.viewProduct || url;
          box.appendChild(text);
          box.appendChild(link);
          content.appendChild(box);
        })
        .then(function () {
          content.removeAttribute('aria-busy');
        });
    }

    document.addEventListener('click', function (event) {
      var opener = event.target.closest('[data-quick-view-open]');
      if (!opener) return;
      if (!Dialog.open(dialog)) {
        window.location.href = opener.dataset.quickViewOpen;
        return;
      }
      load(opener.dataset.quickViewOpen);
    });
  }

  /* Temporizador de demostración: el visitante elige un tiempo (5 a 720 minutos).
     No es una cuenta atrás de urgencia.
     ------------------------------------------------------------------------ */
  function initTimers(root) {
    $$('[data-timer]', root).forEach(function (timer) {
      if (timer.dataset.ready) return;
      timer.dataset.ready = 'true';

      var input = $('[data-timer-input]', timer);
      var output = $('[data-timer-out]', timer);
      var message = $('[data-timer-msg]', timer);
      var strings = { min: 'min', hour: 'h', messages: [] };

      try {
        strings = JSON.parse($('[data-timer-strings]', timer).textContent);
        strings.min = theme.decodeText(strings.min);
        strings.hour = theme.decodeText(strings.hour);
        (strings.messages || []).forEach(function (entry) {
          entry[1] = theme.decodeText(entry[1]);
        });
      } catch (error) {
        /* se mantienen los textos por defecto */
      }

      function pad(number) {
        return String(number).padStart(2, '0');
      }

      function render() {
        var minutes = parseInt(input.value, 10);
        var hours = Math.floor(minutes / 60);
        var rest = minutes % 60;
        var label = hours
          ? hours + ' ' + strings.hour + (rest ? ' ' + rest + ' ' + strings.min : '')
          : minutes + ' ' + strings.min;
        var match = strings.messages.filter(function (entry) {
          return minutes <= entry[0];
        })[0];
        var min = parseInt(input.min, 10);
        var max = parseInt(input.max, 10);

        output.textContent = pad(hours) + ' : ' + pad(rest) + ' : 00';
        message.textContent = label + (match ? ': ' + match[1] : '');
        input.setAttribute('aria-valuetext', label);
        input.style.setProperty('--fill', ((minutes - min) / (max - min)) * 100 + '%');
      }

      /* Oferta al llegar al máximo: una ventana emergente con cuenta atrás. La hora
         de inicio se guarda, así que recargar no reinicia la cuenta. Si se cierra,
         volver a llegar al máximo la reabre mientras quede tiempo; al acabar, no
         vuelve a mostrarse en este navegador. */
      var offer = $('[data-timer-offer]', timer.parentNode);
      var offerKey = 'theme-timer-offer';
      var offerTick = null;

      function offerState(value) {
        try {
          if (value === undefined) return window.localStorage.getItem(offerKey);
          window.localStorage.setItem(offerKey, value);
        } catch (error) {
          /* sin almacenamiento: la oferta funciona solo en esta visita */
        }
        return null;
      }

      function offerLeft(start) {
        var total = parseInt(offer.dataset.seconds, 10) || 300;
        return Math.ceil(total - (Date.now() - start) / 1000);
      }

      function offerEnd() {
        window.clearInterval(offerTick);
        offerTick = null;
        offer.dataset.done = 'true';
        offerState('done');
        if (offer.open) offer.close();
      }

      function offerOpen() {
        if (!offer || offer.dataset.done || offer.open) return;
        var saved = offerState();
        if (saved === 'done') {
          offer.dataset.done = 'true';
          return;
        }
        var start = parseInt(saved, 10);
        if (!start) {
          start = Date.now();
          offerState(String(start));
        }
        if (offerLeft(start) <= 0) {
          offerEnd();
          return;
        }

        var clock = $('[data-timer-offer-clock]', offer);
        function tick() {
          var left = offerLeft(start);
          if (left <= 0) {
            offerEnd();
            return;
          }
          clock.textContent = pad(Math.floor(left / 60)) + ':' + pad(left % 60);
        }

        tick();
        window.clearInterval(offerTick);
        offerTick = window.setInterval(tick, 250);
        Dialog.open(offer);
      }

      /* Comprar: directo al pago con una unidad y el descuento ya aplicado
         (enlace de carrito de Shopify). El código no aparece en la página. */
      timer.parentNode.addEventListener('click', function (event) {
        var buy = event.target.closest('[data-offer-buy]');
        if (!buy || !offer) return;
        var code = '';
        try {
          code = window.atob(offer.dataset.offerKey || '');
        } catch (error) {
          code = '';
        }
        try {
          if (buy.closest('[data-timer-offer]')) window.sessionStorage.setItem(offerKey + '-return', buy.dataset.offerBuy);
        } catch (error) {
          /* sin almacenamiento, la ventana no se reabre sola al volver */
        }
        buy.classList.add('is-loading');
        /* por si la navegación se cancela, el botón no se queda bloqueado */
        window.setTimeout(function () {
          buy.classList.remove('is-loading');
        }, 8000);
        window.location.href = theme.cartPath() + buy.dataset.offerBuy + ':1?discount=' + encodeURIComponent(code);
      });

      /* Al volver del pago sin comprar: la oferta se cierra y deja de estar disponible
         en este navegador. Si aún quedaba tiempo, se pregunta una vez si de verdad se
         quiere perder, con un botón para volver al pago. */
      window.addEventListener('pageshow', function () {
        $$('[data-offer-buy]', timer.parentNode).forEach(function (button) {
          button.classList.remove('is-loading');
        });
        if (!offer) return;
        var variant = null;
        try {
          variant = window.sessionStorage.getItem(offerKey + '-return');
          window.sessionStorage.removeItem(offerKey + '-return');
        } catch (error) {
          variant = null;
        }
        if (!variant) return;
        var start = parseInt(offerState(), 10);
        var hadTime = start && offerLeft(start) > 0;
        offerEnd();
        var leave = $('[data-timer-offer-leave]', timer.parentNode);
        if (!hadTime || !leave) return;
        $('[data-offer-buy]', leave).dataset.offerBuy = variant;
        Dialog.open(leave);
      });

      input.addEventListener('input', function () {
        render();
        if (parseInt(input.value, 10) >= parseInt(input.max, 10)) offerOpen();
      });
      render();
    });
  }

  /* Reseñas bajo el botón de compra: flechas para pasar de tarjeta (también se desliza con el dedo). */
  function initMiniReviews(root) {
    $$('[data-mini-reviews]', root).forEach(function (box) {
      if (box.dataset.ready) return;
      box.dataset.ready = 'true';
      var track = $('[data-mini-reviews-track]', box);
      var arrows = $$('[data-mini-reviews-dir]', box);
      if (!track || !arrows.length) return;
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var update = function () {
        var max = track.scrollWidth - track.clientWidth - 2;
        arrows[0].disabled = track.scrollLeft <= 2;
        arrows[arrows.length - 1].disabled = track.scrollLeft >= max;
      };
      arrows.forEach(function (arrow) {
        arrow.addEventListener('click', function () {
          var card = track.firstElementChild;
          var step = card ? card.getBoundingClientRect().width + 10 : track.clientWidth;
          track.scrollBy({ left: Number(arrow.dataset.miniReviewsDir) * step, behavior: reduce ? 'auto' : 'smooth' });
        });
      });
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }

  /* Nota media calculada con las estrellas de la sección Testimonios de la página
     (bloque «Reseñas bajo el botón» > «Nota media de los testimonios»). */
  function initRatingFromTestimonials() {
    var targets = $$('[data-rating-auto]');
    if (!targets.length) return;
    var stars = $$('[data-t-stars]').map(function (el) { return parseInt(el.dataset.tStars, 10) || 0; })
      .filter(function (n) { return n > 0; });
    if (!stars.length) return;
    var avg = stars.reduce(function (a, b) { return a + b; }, 0) / stars.length;
    var rounded = Math.round(avg * 10) / 10;
    var lang = (document.documentElement.lang || 'es').toLowerCase();
    var text = lang.indexOf('en') === 0 ? rounded.toFixed(1) : rounded.toFixed(1).replace('.', ',');
    targets.forEach(function (el) {
      var bar = $('[data-rating-stars]', el);
      var value = $('[data-rating-value]', el);
      var label = $('[data-rating-label]', el);
      if (bar) bar.style.setProperty('--pct', (avg / 5) * 100 + '%');
      if (value) value.textContent = text;
      if (label) label.textContent = text + ' / 5';
      el.hidden = false;
    });
  }

  /* Plazo de entrega con fechas (snippets/delivery-steps.liquid): cada paso lleva un
     rango de días hábiles («0», «1-2», «15») que aquí se convierte en fechas del
     calendario, sin contar sábados ni domingos. */
  function initDelivery(root) {
    var boxes = $$('[data-delivery]', root);
    if (!boxes.length) return;
    var lang = document.documentElement.lang || 'es';
    var months;
    try {
      months = new Intl.DateTimeFormat(lang, { month: 'short' });
    } catch (error) {
      return;
    }
    /* El día y el mes se montan a mano: así sale «22 oct» en todos los idiomas (en
       portugués, el formato corto del navegador daría «22/10»). En inglés, «Oct 22». */
    var dayFirst = !/^en/i.test(lang);
    function addBusinessDays(start, days) {
      var date = new Date(start.getTime());
      while (days > 0) {
        date.setDate(date.getDate() + 1);
        var weekday = date.getDay();
        if (weekday !== 0 && weekday !== 6) days -= 1;
      }
      return date;
    }
    function label(date) {
      var month = months.format(date).replace(/\./g, '');
      return dayFirst ? date.getDate() + ' ' + month : month + ' ' + date.getDate();
    }
    var today = new Date();
    boxes.forEach(function (box) {
      if (box.dataset.ready) return;
      box.dataset.ready = 'true';
      $$('[data-delivery-range]', box).forEach(function (node) {
        var range = String(node.dataset.deliveryRange || '').split('-').map(function (part) {
          return parseInt(part, 10);
        });
        if (isNaN(range[0]) || range[0] === 0) return;
        var from = addBusinessDays(today, range[0]);
        var to = range.length > 1 && !isNaN(range[1]) ? addBusinessDays(today, range[1]) : from;
        var sameMonth = from.getMonth() === to.getMonth() && from.getFullYear() === to.getFullYear();
        if (to.getTime() === from.getTime()) node.textContent = label(from);
        else if (sameMonth && dayFirst) node.textContent = from.getDate() + '–' + label(to);
        else node.textContent = label(from) + ' – ' + label(to);
      });
    });
  }

  function init(root) {
    initProducts(root);
    initTimers(root);
    initMiniReviews(root);
    initRatingFromTestimonials();
    initDelivery(root);
  }

  init(document);
  initQuickView();
  document.addEventListener('theme:content', function (event) {
    init(event.detail.root);
  });
})();
